import script from "./SignUpForm.vue?vue&type=script&setup=true&lang=js"
export * from "./SignUpForm.vue?vue&type=script&setup=true&lang=js"

import "./SignUpForm.vue?vue&type=style&index=0&id=79ed0462&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79ed0462"]])

export default __exports__